
    import __i18nConfig from '@next-translate-root/i18n'
    import __loadNamespaces from 'next-translate/loadNamespaces'
    import Head from 'next/head';
import CMSHead from '@utility/CMSHead/CMSHead';
import paths, { LoginQueryParams } from '@constants/paths';
import WithProtectedRoute from '@helpers/WithProtectedRoute';
import Page from '@organisms/Page/Page';
import useCmsPage from '@hooks/useCmsPage';
import createFallback, { defaultRevalidationInterval } from '@helpers/fallback';
const label = 'minavanligastevaror';
const MinaVanligasteVarorPage = () => {
    const { cmsPage, isLoading } = useCmsPage(label);
    return (<>
      <CMSHead cmsPage={cmsPage}/>
      <Head>
        <meta name="robots" content="noindex, nofollow"/>
        <meta name="googlebot" content="noindex, nofollow"/>
      </Head>
      <Page cmsPage={cmsPage}/>
    </>);
};
async function getStaticProps() {
    const fallback = await createFallback('ContentPage', label);
    return {
        props: {
            fallback,
            label,
        },
        revalidate: defaultRevalidationInterval,
    };
}
export default WithProtectedRoute(MinaVanligasteVarorPage, paths.MY_COMMON_ITEMS, LoginQueryParams.MY_COMMON_ITEMS);

    async function __Next_Translate__getStaticProps__197a5ece66b__(ctx) {
      const res = await getStaticProps(ctx)
      return {
        
        ...res,
        props: {
          ...(res.props || {}),
          ...(await __loadNamespaces({
            ...ctx,
            ...__i18nConfig,
            pathname: '/minavanligastevaror/MinaVanligasteVarorPage.tsx',
            loaderName: 'getStaticProps',
            loadLocaleFrom: __i18nConfig && __i18nConfig.loadLocaleFrom || ((l, n) => import(`@next-translate-root/locales/${l}/${n}`).then(m => m.default)),
          }))
        }
      }
    }
    export { __Next_Translate__getStaticProps__197a5ece66b__ as getStaticProps }
  